<div class="p-grid container" style="background-color: #eaf9e9; width: 100vw; height: 100vh; overflow: auto;"> 
    <div class="p-col-12" style="padding: 30px;">
        <img src="assets/bwysos.png" alt="logo ancv" srcset="" style="float: left; margin: 10px">
    </div>
    <div class="ui-fluid p-col-12" >
        <div class="container-form">

            <div style="width: 100%;text-align: right;color: #d0dccf; font-family: 'Open Sans', 'Helvetica Neue', sans-serif;">Bienvenue sur votre espace privé</div>

            <div class="p-field p-grid">
                <img src="assets/ancv_logo.jpg" alt="logo ancv" srcset="" style="float: left; max-width: 100px; margin: 10px">
            </div>

            <div class="p-field p-grid">
                <div class="p-col-12">
                    <input id="id" type="text" [(ngModel)]="id" pInputText class="form-element" placeholder="Matricule, identifiant" autocomplete="none"> 
                </div>
            </div>

            <div class="p-field p-grid">
                <div class="p-col-12">
                    <input id="password" type="text" pPassword [feedback]="false" [showPassword]="false" [(ngModel)]="mdp"  class="form-element" placeholder="Mot de passe"> 
                </div>
            </div>

            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6 p-md-offset-6 ui-fluid">
                    <button pButton type="button" label="S'identifier" (click)="login()" style="background-color :#56716a; border-color: #36b32e;"></button>
                </div>
            </div>

        </div>
    </div>
</div>
<p-toast [styleClass]="'message'">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em; font-weight: bold; "></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
    </ng-template>
</p-toast>